import { createContext } from "react";

// Define the type for FormContext
interface FormContextType {
  handleChange: (field_id: string, event: any, clientFormFields: any[], setClientFormFields:(arg: any) => void ) => void;
}

// Create context with correct default value
export const FormContext = createContext<FormContextType | null>(null);
